export const CHATBOT_INITIALIZE_TEXT = 'Type a message...';
export const PLAN_RECOMMENDER_SYSTEM_MESSAGE =
  'Plan Recommender data synchronized!';
export const ID_CARD_LOGIN_SYSTEM_MESSAGE = 'Logged in as ';
export const ID_CARD_LOGOUT_SYSTEM_MESSAGE = 'User logged out.';

// Message limit configuration
/**
 * Maximum number of individual messages to display in UI and send to backend API.
 * MESSAGE_LIMIT = 8 means 8 individual messages (approximately 4 pairs)
 * (excluding welcome message)
 */
export const MESSAGE_LIMIT = 8;

export const TERMS_AND_CONDITIONS_URL = 'https://planyear.ai/privacy-policy';
